module.exports = __webpack_public_path__ + "static/media/ecosentino-logo-negative.e991eb3c.svg";